import React from "react";
import { Layout,Menu } from "antd";
import "./SideBar.css"
import { UploadOutlined,UsergroupAddOutlined ,DashboardOutlined,UserAddOutlined} from '@ant-design/icons';

const { Sider } = Layout;

const SideBar = ({ menu ,changeSelectedKey}) => {

  const topics = [
    {Key:"Login",subKey:["Login"],icon:UserAddOutlined},
    {Key:"Home",subKey:["Home"],icon:DashboardOutlined},
    {Key:"Parent",subKey:["AllStudents","Request"],icon:UsergroupAddOutlined},
    {Key:"CR",subKey:["AllCR","Audit","Rating","Old Records","Attendance"],icon:UsergroupAddOutlined},
    {Key:"Operations",subKey:["Math","English"],icon:UsergroupAddOutlined},
    {Key:"UploadFile",subKey:["Student","CR","Response"],icon:UploadOutlined},
  ]

  const MenuItems = topics.map((obj,index) => {
    return {
      key: obj.Key,
      icon: React.createElement(obj.icon),
      label: obj.Key,
      children: obj.subKey.map((subkey,subkeyindex) => {
        return {
          key: subkey,
          label: subkey,
          onClick : (e)=>{changeSelectedKey(e)}
        };
      }),
    };
  });

  return (
  //   <Layout.Sider
  //     className="sidebar"
  //     breakpoint={"lg"}
  //     theme="light"
  //     collapsedWidth={0}
  //     trigger={null}
  //   >
  //     {menu}
  //  </Layout.Sider>
    <Sider 
    className="site-layout-background sidebar" 
    breakpoint={"lg"}
    theme="light"
    collapsedWidth={0}
    trigger={null}
    width={200}>
    <Menu
      mode="inline"
      defaultSelectedKeys={['Login']}
      defaultOpenKeys={['Login']}
      style={{
        height: '100%',
      }}
      items={MenuItems}
    />
  </Sider>
   );
};
export default SideBar;